import React, { useEffect, useRef, useState } from 'react';
import { FileText, Download, Upload, Trash2, Eye } from 'lucide-react';
import AnteprimaDocumento, { haAnteprima } from '../../components/AnteprimaDocumento';
import api from '../../api/client';
import { TIPI_DOCUMENTO, TIPI_COLLABORATORE, etichettaTipo, nomeDownload, ACCEPT, MAX_MB } from '../../utils/documentiDipendente';

const FORM_VUOTO = { tipo: 'IDENTITA', nome: '', fileData: '', fileName: '' };

export default function DocumentiAllenatore() {
  const [documenti, setDocumenti] = useState([]);
  const [loading, setLoading]     = useState(true);
  const [form, setForm]           = useState(FORM_VUOTO);
  const [caricando, setCaricando] = useState(false);
  const [anteprima, setAnteprima] = useState(null);
  const fileRef = useRef(null);

  const carica = () =>
    api.get('/dipendenti/me/documenti').then(r => setDocumenti(r.data)).catch(() => {}).finally(() => setLoading(false));

  useEffect(() => { carica(); }, []);

  const scarica = async (d) => {
    try {
      const r = await api.get(`/dipendenti/me/documenti/${d.id}/download`, { responseType: 'blob' });
      const url = URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement('a');
      a.href = url; a.download = nomeDownload(d); a.click();
      URL.revokeObjectURL(url);
    } catch (e) { alert('Errore download: ' + (e.response?.data?.error || e.message)); }
  };

  const scegliFile = (e) => {
    const file = e.target.files[0]; if (!file) return;
    if (file.size > MAX_MB * 1024 * 1024) { alert(`File troppo grande (massimo ${MAX_MB} MB).`); e.target.value = ''; return; }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const base64 = ev.target.result.split(',')[1];
      setForm(f => ({ ...f, fileData: base64, fileName: file.name, nome: f.nome || file.name.replace(/\.[^.]+$/, '') }));
    };
    reader.readAsDataURL(file);
  };

  const invia = async () => {
    if (!form.fileData) return alert('Seleziona un file.');
    setCaricando(true);
    try {
      await api.post('/dipendenti/me/documenti', form);
      setForm(FORM_VUOTO);
      if (fileRef.current) fileRef.current.value = '';
      carica();
    } catch (e) { alert('Errore caricamento: ' + (e.response?.data?.error || e.message)); }
    finally { setCaricando(false); }
  };

  const elimina = async (d) => {
    if (!window.confirm(`Eliminare il documento "${d.nome}"?`)) return;
    try { await api.delete(`/dipendenti/me/documenti/${d.id}`); carica(); }
    catch (e) { alert('Errore: ' + (e.response?.data?.error || e.message)); }
  };

  return (
    <div style={{ maxWidth: '720px', margin: '0 auto' }}>
      <div style={{ marginBottom: '20px' }}>
        <h1 style={s.title}>I MIEI DOCUMENTI</h1>
        <p style={s.sub}>Qui trovi i documenti che ti ha caricato lo staff (CUD, certificazioni) e puoi caricare i tuoi (documento d'identità, codice fiscale, certificato medico, qualifiche).</p>
      </div>

      <div style={s.box}>
        <div style={s.boxTitle}>CARICA UN DOCUMENTO</div>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'flex-end', flexWrap: 'wrap' }}>
          <div style={{ flex: '1 1 200px' }}>
            <label style={s.label}>TIPO</label>
            <select style={s.inp} value={form.tipo} onChange={e => setForm(f => ({ ...f, tipo: e.target.value }))}>
              {TIPI_COLLABORATORE.map(k => <option key={k} value={k}>{TIPI_DOCUMENTO[k]}</option>)}
            </select>
          </div>
          <div style={{ flex: '2 1 200px' }}>
            <label style={s.label}>DESCRIZIONE</label>
            <input style={s.inp} value={form.nome} maxLength={150} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} placeholder="es. Carta d'identità fronte/retro" />
          </div>
          <div style={{ flex: '1 1 100%' }}>
            <label style={s.label}>FILE (PDF, JPG o PNG — max {MAX_MB} MB)</label>
            <input ref={fileRef} style={{ ...s.inp, padding: '7px 0' }} type="file" accept={ACCEPT} onChange={scegliFile} />
          </div>
          <button style={s.btnPri} onClick={invia} disabled={caricando}>
            <Upload size={13} /> {caricando ? 'CARICAMENTO...' : 'CARICA'}
          </button>
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#555' }}>Caricamento...</div>
      ) : documenti.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#555', fontSize: 'var(--font-size-sm)' }}>
          <FileText size={28} color="var(--text-dim)" style={{ marginBottom: '10px' }} />
          <div>Nessun documento disponibile al momento.</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          {documenti.map(d => (
            <div key={d.id} style={{ background: 'var(--bg-card,#141414)', border: '1px solid var(--border,#1E1E1E)', borderRadius: '12px', padding: '14px 16px', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FileText size={18} color="#555" />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: 'var(--font-size-sm)', fontWeight: '700', overflowWrap: 'anywhere', cursor: haAnteprima(d) ? 'pointer' : 'default' }} onClick={() => haAnteprima(d) && setAnteprima(d)}>{d.nome}</div>
                <div style={{ fontSize: 'var(--font-size-xs)', color: '#555' }}>
                  {etichettaTipo(d.tipo)}{d.anno ? ` · ${d.anno}` : ''} · {new Date(d.created_at).toLocaleDateString('it-IT')}
                  {' · '}{d.caricato_da_dipendente ? 'caricato da te' : 'dallo staff'}
                </div>
              </div>
              {haAnteprima(d) && (
                <button style={s.btnSec} onClick={() => setAnteprima(d)} title="Anteprima">
                  <Eye size={13} /> VEDI
                </button>
              )}
              <button style={s.btnSec} onClick={() => scarica(d)} title="Scarica">
                <Download size={13} />
              </button>
              {d.caricato_da_dipendente && (
                <button style={{ ...s.btnSec, color: '#EF4444', borderColor: '#EF444430' }} title="Elimina" onClick={() => elimina(d)}>
                  <Trash2 size={13} />
                </button>
              )}
            </div>
          ))}
        </div>
      )}

      {anteprima && <AnteprimaDocumento doc={anteprima} endpoint={`/dipendenti/me/documenti/${anteprima.id}/download`} onClose={() => setAnteprima(null)} />}
    </div>
  );
}

const s = {
  title:    { fontFamily: "'Barlow Condensed'", fontSize: 'var(--font-size-title)', fontWeight: '800', letterSpacing: '2px', margin: 0 },
  sub:      { fontSize: 'var(--font-size-sm)', color: '#777', margin: '4px 0 0' },
  box:      { background: 'var(--bg-card,#141414)', border: '1px solid var(--border2,#2A2A2A)', borderRadius: '12px', padding: '16px', marginBottom: '20px' },
  boxTitle: { fontSize: 'var(--font-size-xs)', fontWeight: '700', letterSpacing: '2px', color: '#555', marginBottom: '12px' },
  label:    { display: 'block', fontSize: '10px', fontWeight: '700', letterSpacing: '1px', color: '#666', marginBottom: '4px' },
  inp:      { width: '100%', boxSizing: 'border-box', background: 'var(--bg-input,#1A1A1A)', border: '1px solid var(--border2,#2A2A2A)', color: 'var(--text,#fff)', borderRadius: '7px', padding: '8px 10px', fontSize: 'var(--font-size-sm)' },
  btnPri:   { display: 'flex', alignItems: 'center', gap: '6px', background: '#C24B08', border: 'none', color: '#fff', borderRadius: '7px', padding: '9px 16px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' },
  btnSec:   { display: 'flex', alignItems: 'center', gap: '6px', background: 'var(--bg-input,#1A1A1A)', border: '1px solid var(--border2,#2A2A2A)', color: 'var(--text)', borderRadius: '7px', padding: '7px 12px', fontSize: '11px', fontWeight: '700', cursor: 'pointer' },
};
